import IntegrationList from "./list";

export default IntegrationList;
